<template>
    <div class="row">
        <div class="col-12">
            <strong>Auf dem Laufenden bleiben asd as</strong>
        </div>
        <div class="col-12">
            <input
                    type="email"
                    v-model="email"
                    class="required email form-control"
                    placeholder="E-Mail-Adresse"
            >
            <span class="bottom-label"><i class="fas fa-lock"></i> Sicherheit durch SSL-Verschlüsselung</span><br>
        </div>
        <div class="col-12 mt-2 mt-md-4">
            <button type="button" name="subscribe" @click="submit"
                   id="mc-embedded-subscribe"
                   class="btn btn-outline-secondary btn-block hvr-icon-forward">
                Newsletter abonnieren
            </button>
        </div>
        <div class="col-12">
            <p style="font-size: 0.60rem !important; line-height: 0.9rem" class="mb-0">
                Ich möchte künftig mit dem personalisierten FAAREN-Newsletter informiert werden. Wir
                verwenden
                deine Daten ausschließlich gemäß unserer <a :href="privacyUrl"
                                                            target="_blank">Datenschutzrichtlinien</a>.
                Du kannst dich jederzeit von unserem Newsletter abmelden, indem du den Link im unteren
                Teil
                der E-Mail anklickst.
            </p>
        </div>
    </div>
</template>

<script>
  export default {
    name: "NewsletterBox",

    props: {
      privacyUrl: {
        type: String,
        required: true
      }
    },

    data(){
      return {
        email: '',
        name: '',
        gender: ''
      }
    },

    methods: {
      submit(){
        console.log("Abschicken!");
      }
    },

    mounted () {
      console.log("Ich komme aus der Komponente!");
    }
  }
</script>

<style scoped>

</style>
